const amountActiveSessionExceeded =  "The total active user sessions for this user has been reached. Please try again later or contact us on 1300 30 40 63 for assistance.";

export  {
    amountActiveSessionExceeded
}